import React from 'react'

import Membro from './Membro'
import Externo from './Externo'

export default class NavEtica extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    logout() {
        localStorage.clear()

        window.location = "/etica"
    }

    render() {
        if (localStorage.tipoE !== "externo") {
            return (
                <Membro />
            )
        } else {
            return (
                <Externo />
            )
        }
    }
} 